import { DAY_FORMAT, IRestaurantDateStats, SERVER_DATE_FORMAT, StringUtils } from '@localina/core';
import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    stats: IRestaurantDateStats[];
    activeIndex: number;
    onChange: (index: number) => void;
}

const DAY_ONLY_FORMAT = 'dd.MM.';

export const RestaurantStatsWeekStrip: React.FC<IProps> = (props) => {
    const { i18n, t } = useTranslation();

    return (
        <div className="restaurant-stats__week-strip" role="tablist">
            {props.stats.map((stat, index) => {
                const date = DateTime.fromFormat(stat.date, SERVER_DATE_FORMAT);
                return (
                    <button
                        key={stat.date}
                        type="button"
                        role="tab"
                        aria-selected={index === props.activeIndex}
                        className={StringUtils.combineStrings([
                            'restaurant-stats__week-strip__day',
                            index === props.activeIndex && 'is-active',
                        ])}
                        onClick={() => props.onChange(index)}
                    >
                        <span className="restaurant-stats__week-strip__day__date">
                            <span className="restaurant-stats__week-strip__day__date__weekday">
                                {date.toFormat(DAY_FORMAT, { locale: i18n.language })}
                            </span>
                            <span className="restaurant-stats__week-strip__day__date__day">
                                {date.toFormat(DAY_ONLY_FORMAT, { locale: i18n.language })}
                            </span>
                        </span>
                        <span className="restaurant-stats__week-strip__day__counts">
                            <span className="restaurant-stats__week-strip__day__counts__reservations">
                                {t('dashboard.weekStrip.reservationsCount', {
                                    count: stat.occupancyStats.numberOfReservations,
                                })}
                            </span>
                            <span className="restaurant-stats__week-strip__day__counts__guests">
                                {t('dashboard.weekStrip.guestsCount', {
                                    count: stat.occupancyStats.numberOfGuests,
                                })}
                            </span>
                        </span>
                    </button>
                );
            })}
        </div>
    );
};
